import { render, staticRenderFns } from "./PayPalPro.vue?vue&type=template&id=50b2cf78"
import script from "./PayPalPro.vue?vue&type=script&lang=js"
export * from "./PayPalPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports